
import React, { Component } from "react";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,

} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,
            modal_signature_detail: false,
            modal_signature: false,

            loading: false,
            data: null,

            tab: 1,

            signature: "",
            job_id: "",
            member_name: "",
            license_plate: "",
            status: "",
            repair_date: "",
            complete_date: "",
            model_id: "",
            insurance_id: "",
            insurance_name: "",
            contestant_name: "",
            description: "",

            front_cheeks: "",
            front_door: "",
            narrow_back: "",
            sedan_roof: "",
            front_panel: "",
            front_bumper: "",
            lights_front_bumper: "",
            headlight: "",
            front_turn_signal: "",
            front_fender: "",

            oil: false,
            tools: false,
            spare_tire: false,
            air: false,
            air_description: "",
            other: false,
            other_description: "",

            driver_license: false,
            vehicle_registration: false,
            insurance_policy: false,
            id_card: false,
            company_certificate: false,

            page: 1,
            data_search: "",
            filter_status: "",

            license_plate: "",

        }
    }
    async componentDidMount() {
        if (this.props.location.query.member_code) {
            this.GetFromMember(this.props.location.query.member_code);
        }
        else {
            this.Get();
        }
    }

    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            job_id: "",
            filter_status: this.state.filter_status,
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }

    GetFromMember = async (member_code) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: member_code,
            job_id: "",
            filter_status: "",
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            let item = {
                data: {
                    data_list: result.data
                }
            }
            this.setState({ data: item });
        }
        this.setState({ loading: false });
    }
    GetById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            job_id: id
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            this.setState({
                job_id: id,
                job_number: result.data.job_number,
                license_plate: result.data.license_plate,
                brand_name: result.data.brand_name,
                model_name: result.data.model_name,
                repair_date: result.data.repair_date,
                complete_date: result.data.complete_date,
                modal_update: true
            });
        }
        this.setState({ loading: false });
    }
    Delete = async () => { 
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/job-repair/delete/" + this.state.job_id, null);
        if (result && result.status) {
            success_url("/manage-repair/list-repair")
        }
        this.setState({ loading: false });
    }
    trim = () => {
        this.setState({ signature: this.sigPad.getTrimmedCanvas().toDataURL('image/png').split(",")[1] })
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการงานซ่อม" page3="จัดการแจ้งซ่อม"/>
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between test">
                            <h3 className="mb-2"><b>จัดการแจ้งซ่อม {this.props.location.query.member_code ? this.props.location.query.member_code + " : " + this.props.location.query.member_name : ""}</b></h3>
                        </div>
                        {!this.props.location.query.member_code && (
                            <div className="row mb-2 mx-0">
                                <div className="mb-2 col-6 col-md-3" onClick={() => {
                                    if (this.state.filter_status === 1) {
                                        this.setState({ filter_status: "" });
                                    } else {
                                        this.setState({ filter_status: 1 });
                                    }
                                    setTimeout(() => {
                                        this.Get()
                                    }, 10);
                                }}>
                                    <div className={this.state.filter_status === 1 ? "card bg-primary text-white border-0 p-3 w-100 rounded" : "card bg-primary-light text-primary border-0 p-3 w-100 rounded"}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6><b>นัดเข้าซ่อม</b></h6>
                                            <h3><b>{this.state.data ? this.state.data.data.count_s1 : "0"}</b></h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 col-6 col-md-3" onClick={() => {
                                    if (this.state.filter_status === 2) {
                                        this.setState({ filter_status: "" });
                                    } else {
                                        this.setState({ filter_status: 2 });
                                    }
                                    setTimeout(() => {
                                        this.Get()
                                    }, 10);
                                }}>
                                    <div className={this.state.filter_status === 2 ? "card bg-primary text-white border-0 p-3 w-100 rounded" : "card bg-primary-light text-primary border-0 p-3 w-100 rounded"}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6><b>รับรถเข้าซ่อม</b></h6>
                                            <h3><b>{this.state.data ? this.state.data.data.count_s2 : "0"}</b></h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 col-6 col-md-3" onClick={() => {
                                    if (this.state.filter_status === 3) {
                                        this.setState({ filter_status: "" });
                                    } else {
                                        this.setState({ filter_status: 3 });
                                    }
                                    setTimeout(() => {
                                        this.Get()
                                    }, 10);
                                }}>
                                    <div className={this.state.filter_status === 3 ? "card bg-primary text-white border-0 p-3 w-100 rounded" : "card bg-primary-light text-primary border-0 p-3 w-100 rounded"}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6><b>สั่งอะไหล่</b></h6>
                                            <h3><b>{this.state.data ? this.state.data.data.count_s3 : "0"}</b></h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 col-6 col-md-3" onClick={() => {
                                    if (this.state.filter_status === 4) {
                                        this.setState({ filter_status: "" });
                                    } else {
                                        this.setState({ filter_status: 4 });
                                    }
                                    setTimeout(() => {
                                        this.Get()
                                    }, 10);
                                }}>
                                    <div className={this.state.filter_status === 4 ? "card bg-primary text-white border-0 p-3 w-100 rounded" : "card bg-primary-light text-primary border-0 p-3 w-100 rounded"}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6><b>กำลังซ่อม</b></h6>
                                            <h3><b>{this.state.data ? this.state.data.data.count_s4 : "0"}</b></h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 col-6 col-md-4" onClick={() => {
                                    if (this.state.filter_status === 5) {
                                        this.setState({ filter_status: "" });
                                    } else {
                                        this.setState({ filter_status: 5 });
                                    }
                                    setTimeout(() => {
                                        this.Get()
                                    }, 10);
                                }}>
                                    <div className={this.state.filter_status === 5 ? "card bg-primary text-white border-0 p-3 w-100 rounded" : "card bg-primary-light text-primary border-0 p-3 w-100 rounded"}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6><b>ซ่อมสำเร็จ</b></h6>
                                            <h3><b>{this.state.data ? this.state.data.data.count_s5 : "0"}</b></h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 col-6 col-md-4" onClick={() => {
                                    if (this.state.filter_status === 6) {
                                        this.setState({ filter_status: "" });
                                    } else {
                                        this.setState({ filter_status: 6 });
                                    }
                                    setTimeout(() => {
                                        this.Get()
                                    }, 10);
                                }}>
                                    <div className={this.state.filter_status === 6 ? "card bg-primary text-white border-0 p-3 w-100 rounded" : "card bg-primary-light text-primary border-0 p-3 w-100 rounded"}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6><b>ส่งมอบ</b></h6>
                                            <h3><b>{this.state.data ? this.state.data.data.count_s6 : "0"}</b></h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 col-6 col-md-4" onClick={() => {
                                    if (this.state.filter_status === 7) {
                                        this.setState({ filter_status: "" });
                                    } else {
                                        this.setState({ filter_status: 7 });
                                    }
                                    setTimeout(() => {
                                        this.Get()
                                    }, 10);
                                }}>
                                    <div className={this.state.filter_status === 7 ? "card bg-primary text-white border-0 p-3 w-100 rounded" : "card bg-primary-light text-primary border-0 p-3 w-100 rounded"}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6><b>ปิดงาน</b></h6>
                                            <h3><b>{this.state.data ? this.state.data.data.count_s7 : "0"}</b></h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="w-100 card border-0">
                            {!this.props.location.query.member_code ? (
                                <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                    <input
                                        className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                        onKeyUp={(e) => {
                                            if (e.key === "Enter") {
                                                this.setState({ page: 1 });
                                                setTimeout(() => {
                                                    this.Get();
                                                }, 10);
                                            }
                                        }}
                                        value={this.state.data_search}
                                    />

                                    <button className="btn btn-orange mx-1 mb-2" onClick={() => {
                                        this.setState({ page: 1 });
                                        setTimeout(() => {
                                            this.Get();
                                        }, 10);
                                    }}>
                                        ค้นหา
                                    </button>
                                    <button className="btn btn-outline-orange mx-1 mb-2" onClick={() => {
                                        this.setState({ page: 1, data_search: "" });
                                        setTimeout(() => {
                                            this.Get();
                                        }, 10);
                                    }}>
                                        รีเซ็ต
                                    </button>
                                </div>
                            ) : (
                                <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                    <input
                                        className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ license_plate: e.target.value }) }}
                                        value={this.state.license_plate}
                                    />

                                    <button className="btn btn-orange mx-1" onClick={() => { }}>
                                        ค้นหา
                                    </button>
                                    <button className="btn btn-outline-orange mx-1" onClick={() => {
                                        this.setState({ license_plate: "" });
                                    }}>
                                        รีเซ็ต
                                    </button>
                                </div>
                            )}
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">เลขที่งานซ่อม</th>
                                            <th className="text-left text-white">ชื่อลูกค้า</th>
                                            <th className="text-center text-white">ทะเบียนรถ</th>
                                            <th className="text-center text-white">สถานะ</th>
                                            <th className="text-center text-white">วันที่นัด</th>
                                            <th className="text-left text-white">หมายเหตุ</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.data_list.filter(item => !this.state.license_plate || item.license_plate.includes(this.state.license_plate)).map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.job_number ? item.job_number : "-"}</td>
                                                <td className="text-left">{item.member_name ? item.member_name : "-"}</td>
                                                <td className="text-center">{item.license_plate ? item.license_plate : "-"}</td>
                                                <td className="text-center">{item.job_status === 1 ? "นัดเข้าซ่อม" :
                                                    item.job_status === 2 ? "รับรถเข้าซ่อม" :
                                                        item.job_status === 3 ? "สั่งอะไหล่" :
                                                            item.job_status === 4 ? "กำลังซ่อม" :
                                                                item.job_status === 5 ? "ซ่อมสำเร็จ" :
                                                                    item.job_status === 6 ? "ส่งมอบ" :
                                                                        item.job_status === 7 ? "ปิดงาน" : "-"}</td>
                                                <td className="text-center">{item.repair_date ? format_date(item.repair_date) : "-"}</td>
                                                <td className="text-left">{item.remark ? item.remark : "-"}</td>
                                                < td className="text-center" >
                                                    <div className="w-100 d-flex justify-content-center">
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-cyan-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => { window.location.href = "/manage-repair/repair/update?id=" + item.job_id + "&type=read" }}>
                                                            <label className="pointer icon text-cyan p-2">{"\uf15b"}</label>
                                                        </div>
                                                        {item.job_status < 7 && (
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                                onClick={() => { window.location.href = "/manage-repair/repair/update?id=" + item.job_id }}>
                                                                <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                            </div>
                                                        )}
                                                        {item.job_status < 5 && (
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        modal_delete: true,
                                                                        job_id: item.job_id,
                                                                        job_number: item.job_number
                                                                    })
                                                                }}>
                                                                <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && !this.props.location.query.member_code && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div >
                {/* delete */}
                < Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ลบงานซ่อม</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบงานซ่อม “{this.state.job_number}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.Delete() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal >
            </div >
        )
    }
}
